import React, {Component, Fragment} from "react";
import loading from "./images/25.gif";
import notavailable from "./images/no-photo.jpg";
import './safeimage.css';

export class SafeImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      errored: false
    }
  }

  onError() {
    this.setState({errored: true});
  }

  onLoad() {
    this.setState({loaded: true});
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.src !== this.props.src) {
      this.setState({loaded: false, errored: false});
    }
    return true;
  }

  render() {
    return (
      <Fragment>
        {!this.state.loaded && !this.state.errored && (
          <img src={loading} style={{marginTop: 50}}/>
        )}
        {this.state.errored ?
          <img src={notavailable} width={this.props.width} height={this.props.height}/>
          :
          <img src={this.props.src}
               {...this.props}
               style={!this.state.loaded ? {display: "none"} : {}}
               onError={() => this.onError()}
               onLoad={() => this.onLoad()}/>
        }
      </Fragment>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Shared/SafeImage.js